import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import DriverEmployer from './components/DriverEmployer';
import DriverEmployerModal from '../AddOrUpdate/components/DriverEmployerModal';
import PndApi from '../../../../utils/pnd/PndRestApi';
import SnackbarContent from '@mui/material/SnackbarContent';
import LinearProgress from '@mui/material/LinearProgress';
import { Box } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import { showNotification } from 'src/shared/components/Notification';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
import PageHeader from 'src/shared/components/layout/PageHeader';


const DriverEmployerDetailsIndex = () => {
  useEffect(() => {
    getAllDriverEmployerDetails();
  }, [])
  const [reactTableData, setReactTableData] = useState([]);
  const [temp, setTempData] = useState("");
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const [loading, setLoading] = useState(false);

  const getAllDriverEmployerDetails = async () => {
    try {
      setLoading(true);
      const response = await PndApi.GetAllDriverEmployer();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableRowsData: response.data.data });
      } else if (response?.data?.status && response?.data?.status === 204) { //No Record Found
        setNoRecordFound(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response?.data?.message ? response?.data?.message : ERROR_MESSAGES.tryCatchError}`,

        );
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,

      );
    } finally {
      setLoading(false);
    }
  };

    const add = () => {
    setTempData(null);
    setViewDetailPopup(true);
    setTitle("Add Leased Rider Agency");
  };

  const edit = async (event) => {
    if (event.driverEmployerId) {
      setTempData(event);
      setViewDetailPopup(true);
      setTitle("Edit - Leased Rider Agency Details");
    }
  }

  return (
    <Box sx={{ p: 3, backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      <Container fluid style={{ maxWidth: '1400px' }}>

        <PageHeader
          icon={<GroupIcon fontSize="large" />}
          title="Leased Rider Agencies"
          subtitle="Manage leased rider agency companies and their credentials."
          gradient="linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)"
        />

        {loading && <LinearProgress sx={{ mb: 2, borderRadius: 2 }} />}

        <Box sx={{ position: 'relative' }}>
          {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && !isNoRecordFound && <DriverEmployer reactTableData={reactTableData} onAdd={add} onEdit={edit} />}
          {isNoRecordFound && <DriverEmployer isNoRecordFound={isNoRecordFound} onAdd={add} onEdit={edit} />}
          {/* {isNoRecordFound && <SnackbarContent message={'No Record Found'} />} */}
        </Box>

        {viewDetailPopup &&
          <DriverEmployerModal
            modalShow={viewDetailPopup}
            setModalShow={setViewDetailPopup}
            dataInfo={temp}
            isTitle={isTitle}
          />}
      </Container>
    </Box>
  );
};

export default DriverEmployerDetailsIndex;